import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {UserDto} from '../../../user/data/userDto';
import {ChatService} from '../../services/chat.service';
import {ChatRoomDto, CreateChatRoomRequest} from '../../models/createChatRoomRequest';
import {PleaseWaitService} from '../../../app-common/services/please-wait/please-wait.service';
import {ElectronService} from 'ngx-electron';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Component({
  selector: 'app-main-chat',
  templateUrl: './main-chat.component.html',
  styleUrls: ['./main-chat.component.scss']
})
export class MainChatComponent implements OnInit {

  @Input() expandEvent: EventEmitter<void>;
  closed: boolean = true;
  createChatDialogVisible: boolean = false;
  newChatRoomName: string = '';
  chatInvitations: UserDto[] = [undefined];
  selectedChat: ChatRoomDto;

  constructor(private chatService: ChatService,
              private pleaseWaitService: PleaseWaitService,
              private electronService: ElectronService,
              private loggingService: LoggerService) { }

  get isElectron() {
    return this.electronService.isElectronApp;
  }

  get canAddInvite() {
    for (const invitation of this.chatInvitations) {
      if (invitation === undefined) {
        return false;
      }
    }
    return true;
  }

  get canCreateChat() {
    if (this.newChatRoomName.length === 0) {
      return false;
    }
    if (this.chatInvitations.length === 0) {
      return false;
    }
    for (const invitation of this.chatInvitations) {
      if (invitation === undefined) {
        return false;
      }
    }
    return true;
  }

  ngOnInit(): void {
    this.expandEvent.subscribe(() => {
      this.closed = false;
    });
  }

  resetInvitations() {
    this.chatInvitations = [undefined];
  }

  addInvitation() {
    this.chatInvitations.push(undefined);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.MainChat, 'Added invitation.');
  }

  close() {
    this.closed = true;
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.MainChat, 'Closed window.');
  }

  newChatButton() {
    this.createChatDialogVisible = true;
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.MainChat, 'Opened new chat window.');
  }

  removeInvitation(i: number) {
    this.chatInvitations.splice(i, 1);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.MainChat, 'Removed invitation with number ' + i);
  }

  setInvitation($event: UserDto, i: number) {
    this.chatInvitations[i] = $event;
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.MainChat, 'Set invitation with number ' + i + ' to user ' + $event.username + ' with id ' + $event.accountId);
  }

  resetCreateChatForm() {
    this.resetInvitations();
    this.newChatRoomName = '';
  }

  async createChat() {
    try {
      this.pleaseWaitService.addToQueue();
      const request = new CreateChatRoomRequest();
      request.roomName = this.newChatRoomName;
      request.participants = this.chatInvitations.map(x => x.accountId);
      const dict = {};
      for (const participant of request.participants) {
        dict[participant.toString()] = participant;
      }
      request.participants = Object.values(dict);
      await this.chatService.createChatRoom(request);
      this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.MainChat, 'Created chat room ' + request.roomName);
      this.resetCreateChatForm();
      this.createChatDialogVisible = false;
      this.pleaseWaitService.removeFromQueue();
    } catch (e) {
    } finally {
      this.pleaseWaitService.removeFromQueue();
    }
  }

  selectChat($event: ChatRoomDto) {
    this.selectedChat = $event;
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.MainChat, 'Selected chat room with id ' + $event.room.id);
  }
}
